// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"220":"1fe4cc21","257":"8d05f577","341":"5af6f24f","353":"cdbf54fa","453":"8ab44547","889":"a9e00ae6","975":"39a304c9"}[chunkId] + ".chunk.js";
};